// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

// export const environment = {
//   production: false,
//   // envName: "Prod",
//   envName: "",
//   dbPrefix: "",
//   snsurl: "https://preprod-sms.rntbciconnect.com/token",
//   firebase: {
//     apiKey: "AIzaSyBfEKUcykzjyMHIUbNZbH4NCTLeIHg7UpI",
//     authDomain: "cabtrack-6cb6e.firebaseapp.com",
//     databaseURL: "https://cabtrack-6cb6e.firebaseio.com",
//     projectId: "cabtrack-6cb6e",
//     storageBucket: "cabtrack-6cb6e.appspot.com",
//     messagingSenderId: "523233495121",
//   },
//   // Stagging
//   myAppConfig: {
//     aws_appsync_graphqlEndpoint:
//       "https://w4tjgxrxvnguldsclbiqylytm4.appsync-api.ap-south-1.amazonaws.com/graphql",
//     aws_appsync_region: "ap-south-1",
//     aws_appsync_authenticationType: "API_KEY",
//     aws_appsync_apiKey: "da2-fagrx6qwjvcgxfq4pywmllx3xa"//"da2-xi2l46vzbrgkpgjgofklofst4m", // "da2-4v2apg77jvgnjpkvyvh4lkxebi"// "da2-qcuqmnkwyrev7pxws67x7gkh7a"
//   },
//   mySafeCabURL: "https://preprod-safecab.rntbciconnect.com/",
//   AWSS3BucketCredentials: {
//         accessKeyId: 'AKIA5NIG4PFNJ6NPFS7G',
//         secretToken: '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',
//         region: 'ap-south-1',
//         bucketName: 'rnconnect-ope',
//       },
    
//   emailUrl: 'https://preprod-sms.rntbciconnect.com/email',
//   smsUrl: 'https://preprod-sms.rntbciconnect.com',
//   // smsUrl: 'http://localhost:3060',
//   fcmUrl: 'https://fcm.googleapis.com/v1/projects/rnconnect--int/messages:send'
// };

export const environment = {
  production: true,
  envName: "Prod",
  dbPrefix: "Prod",
  enableLogging: true ,
  // envName: "",
  snsurl: "https://safecab-sms.rntbciconnect.com/token",
  firebase: {
    apiKey: "AIzaSyBfEKUcykzjyMHIUbNZbH4NCTLeIHg7UpI",
    authDomain: "cabtrack-6cb6e.firebaseapp.com",
    databaseURL: "https://cabtrack-6cb6e.firebaseio.com",
    projectId: "cabtrack-6cb6e",
    storageBucket: "cabtrack-6cb6e.appspot.com",
    messagingSenderId: "523233495121",
  },

  // Production
  myAppConfig: {
    // ...
    aws_appsync_graphqlEndpoint:
      "https://kufslz7ccfddlhnyj7fbngmozi.appsync-api.ap-south-1.amazonaws.com/graphql",
    aws_appsync_region: "ap-south-1",
    aws_appsync_authenticationType: "API_KEY",
    aws_appsync_apiKey: "da2-vhw5yvsnvfap5gjm6zaxo6ns2a", //'da2-xej2cau5jvdw5dqrqsozfpdknq'
  },
  mySafeCabURL: "https://safecab.rntbciconnect.com/",
  
  AWSS3BucketCredentials: {
    accessKeyId: 'AKIA5NIG4PFNJ6NPFS7G',
    secretToken: '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',
    region: 'ap-south-1',
    bucketName: 'rnconnect-ope',
  },
  emailUrl: 'https://safecab-sms.rntbciconnect.com/email',
  smsUrl: 'https://safecab-sms.rntbciconnect.com',
  fcmUrl: 'https://fcm.googleapis.com/v1/projects/rnconnect-ope/messages:send'
};
